export default "__VITE_ASSET__DR_roE4X__"